"use client";
import React from "react";
import "./css/brands.css";
import { useRouter, useParams } from "next/navigation";
import { useTranslations } from "next-intl";
import productsJSON from "@/data/products.json";
import { slugify } from "@/utils/commonFuncs";
import ResponsiveImage from "./ResponsiveImage";
/* import { translateText as t } from "../../store/reducers/language"; */

function Brands() {
    const router = useRouter();
    const { locale } = useParams();
    const t = useTranslations("Brands");

    const getProductSlug = (id) => {
        const product = productsJSON.find((item) => item.id === id);
        if (!product) {
            return id.toString();
        }
        return id.toString() + "-" + slugify(product.name[locale]);
    };

    return (
        <div className="brands mx-3 md:mx-10 overflow-hidden">
            <div className="content">
                <div className="headerContainer">
                    <h2 color="white">{t("ourGroupCompanies")}</h2>
                </div>
                <div className="images">
                    <div className="imgContainer">
                        <a href="https://www.pomzaexport.com/" target="_blank">
                            <ResponsiveImage
                                src="/assets/logo/pomzaexport-logo-white.png"
                                alt="pomza export"
                            />
                        </a>
                    </div>
                    <div className="imgContainer">
                        <a href="https://www.eilepomex.com/" target="_blank">
                            <ResponsiveImage
                                src="/assets/logo/eilepomex-logo-white.png"
                                alt="eile pomex"
                            />
                        </a>
                    </div>
                </div>
                <div className="images">
                    <div className="imgContainer">
                        <a href="http://www.persanyapi.com.tr/" target="_blank">
                            <ResponsiveImage
                                src="/assets/logo/persan-logo-white.png"
                                alt="persan"
                            />
                        </a>
                    </div>
                    <div className="imgContainer">
                        <a href="http://www.erper.com.tr/" target="_blank">
                            <ResponsiveImage
                                src="/assets/logo/erper-logo-white.png"
                                alt="erper"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div className="content-border desktop-separator"></div>
            <div className="content-border-h mobile-separator"></div>
            <div className="content">
                <div className="headerContainer">
                    <h2 color="white">{t("ourBrands")}</h2>
                </div>
                <div className="images">
                    <div className="imgContainer">
                        <ResponsiveImage
                            className="cursor-pointer"
                            onClick={() =>
                                router.push(
                                    "/" + locale + "/product/" + getProductSlug(7)
                                )
                            }
                            src="/assets/logo/etiper-logo-white.png"
                            alt="etiper"
                        />
                    </div>
                    <div className="imgContainer">
                        <ResponsiveImage
                            className="cursor-pointer"
                            onClick={() =>
                                router.push(
                                    "/" + locale + "/product/" + getProductSlug(1)
                                )
                            }
                            src="/assets/logo/sardesquartz-logo-white.png"
                            alt="sardes quartz"
                        />
                    </div>
                    <div className="imgContainer">
                        <ResponsiveImage
                            className="cursor-pointer"
                            onClick={() =>
                                router.push(
                                    "/" + locale + "/product/" + getProductSlug(9)
                                )
                            }
                            src="/assets/logo/emerex-logo-white.png"
                            alt="emerex"
                        />
                    </div>
                </div>
                <div className="images">
                    <div className="imgContainer">
                        <a
                            href="https://www.eilepomex.com/pomexblok"
                            target="_blank"
                        >
                            <ResponsiveImage
                                src="/assets/logo/pomexblok-logo-white.png"
                                alt="pomex blok"
                            />
                        </a>
                    </div>
                    <div className="imgContainer">
                        <ResponsiveImage
                            className="cursor-pointer"
                            onClick={() =>
                                router.push(
                                    "/" + locale + "/product/" + getProductSlug(4)
                                )
                            }
                            src="/assets/logo/pomexgarnet-logo-white.png"
                            alt="pomex garnet"
                        />
                    </div>
                    <div className="imgContainer">
                        <ResponsiveImage
                            className="cursor-pointer"
                            onClick={() =>
                                router.push(
                                    "/" + locale + "/product/" + getProductSlug(10)
                                )
                            }
                            src="/assets/logo/pomexbeton-logo-white.png"
                            alt="pomex beton"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Brands;
